module.exports = __webpack_public_path__ + "img/9788946418080.c03cf4ca.jpg";